import { Component } from '@angular/core';
import { membersuiteRegistrationFeeEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Registration Fees') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiteregistrationfee-form',
    templateUrl: './membersuiteregistrationfee.form.component.html'
})
export class membersuiteRegistrationFeeFormComponent extends BaseFormComponent {
    public record!: membersuiteRegistrationFeeEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

